import { PetType } from '@rover/types/src/Pet';

export type Review = {
  comment?: string;
  wouldRebook?: boolean;
  conversationOpk?: string;
  converstionUrlForReload?: string;
  // TODO: keep them optional until M1 flag is cleaned
  //  Cleanup ticket https://roverdotcom.atlassian.net/browse/DEV-82211
  //  Add new BE fields ticket https://roverdotcom.atlassian.net/browse/DEV-81257
  isComplete: boolean;
};

export type ReviewResponse = {
  successUrl: string;
  reviewId: number;
  reviewOpk: string;
  success: boolean;
};

export type QuestionOptions = {
  slug: string;
  value: string;
};

export type Question = {
  question: string;
  options: QuestionOptions[];
  multiselect: boolean;
  slug: string;
};

export type ReviewPetDetailsOptions = {
  topic: string;
  questions: Question[];
};

export type PetDetails = {
  detail: string;
  value: string;
};

export type ReviewPet = {
  pet: string;
  topic: string;
  comment?: string;
  isComplete: boolean;
  petDetails: PetDetails[];
  conversationOpk?: string;
  converstionUrlForReload?: string;
  wouldRebook?: boolean;
};

export enum RevieweeType {
  PET = 'pet',
  OWNER = 'owner',
}

// TODO: type should remain optional until we get the the pet details/owner details from the API call.
//  We need to use this instead of PetInfo so that we have a single type for both M1/M3
export type RevieweeInfo = {
  opk: string;
  name: string;
  profilePhoto?: string | null;
  type?: RevieweeType;
  petType?: PetType;
};

export type PendingReviews = {
  reviews: RevieweeInfo[];
};

export enum ReviewStatus {
  NOT_STARTED = 'not_started',
  PENDING = 'pending',
  FINISHED = 'finished',
  COMPLETE = 'complete',
}

export type ReportReviewStatus = {
  canReport: boolean | null;
  reviewStatus: ReviewStatus;
  reportRedirectUrl: string;
  reviewId: number | null;
};

export enum StayReviewStatus {
  NOT_OPEN_YET = 'not_open_yet',
  PENDING = 'pending',
  STARTED = 'started',
  OMITTED = 'omitted',
  SKIPPED = 'skipped',
  COMPLETED = 'completed',
}

export type StayReviewResult = {
  status: StayReviewStatus;
  copy: string;
  url: string;
  showRating: boolean;
  reviewWindowInDays: number;
};
